import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchArticles, fetchCategories } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";
import { AdSlot } from "@/components/AdSlot";
import { VideoStrip } from "@/components/VideoStrip";
import { Seo } from "@/components/Seo";

export default function Category() {
  const { slug } = useParams();
  const [articles, setArticles] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchArticles({ category: slug })
      .then(setArticles)
      .finally(() => setLoading(false));
    fetchCategories().then((cats) => setMeta(cats.find((c) => c.slug === slug)));
  }, [slug]);

  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16">
      <Seo
        title={meta?.name || slug}
        description={meta?.blurb || `The latest ${slug} stories from NERO SUN.`}
        path={`/c/${slug}`}
      />
      <div className="border-b border-white/10 pb-10">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-signal">Section</span>
        <h1 className="font-anton text-6xl md:text-8xl uppercase tracking-tight mt-3 leading-none" data-testid="category-title">
          {meta?.name || slug}
        </h1>
        {meta?.blurb && <p className="text-muted-foreground text-lg mt-4 max-w-2xl">{meta.blurb}</p>}
      </div>

      {slug === "media" && <VideoStrip category="media" title="On Screen" limit={3} />}

      {loading ? (
        <p className="font-mono text-sm text-muted-foreground mt-10">Loading…</p>
      ) : articles.length === 0 ? (
        <p className="font-mono text-sm text-muted-foreground mt-10" data-testid="category-empty">
          No stories in this section yet.
        </p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {articles.map((a, i) => (
            <ArticleCard key={a.slug} article={a} index={i} />
          ))}
          <AdSlot variant="infeed" slot={process.env.REACT_APP_ADSENSE_SLOT_INFEED} className="sm:col-span-2 lg:col-span-1" />
        </div>
      )}
    </div>
  );
}
